import React, { memo } from "react";
import { IconFontLayer } from "../../../../../../../icon-font/iconfont-layer";
import { textStyleSet } from "../../../../../../../mui-theme/text.style";
import { styles } from "../license-exam-entrance-card.style";
import { useMockExamEntranceCard } from "./mock-exam-entrance-card.hook";
import { color } from "../../../../../../../mui-theme/palette";
import { useCandidateHome } from "../../../candidate-home.hook";
import { IconFont } from "../../../../../../../icon-font/iconfont";
import mockExamIcon from "../../../../../../../components/icon/assets/mock-exam-m.svg"; // PHKL Custom
import { useTranslation } from "react-i18next"; // PHKL Custom

interface ComponentProps {
  clickMockExam: () => Promise<void>;
}

export const MockExamEntranceCardComponent: React.FC<ComponentProps> = memo(
  ({ clickMockExam /* PHKL Custem */ }: ComponentProps) => {
    const { t } = useTranslation(); // PHKL Custom
    const {
      handlePress,
      translations,
      displayedMockExams,
      mockExamEnabled,
      mappingStatusText,
      mappingStatusDesc,
      isExpanded,
      showViewMore,
      handleToggleExpand,
    } = useMockExamEntranceCard();
    // const { clickMockExam } = useCandidateHome();
    if (!mockExamEnabled) {
      return null;
    }
    // PHKL Custom -s
    // COE Original Layout
    // return (
    //   <div className="py-3">
    //     <div className="flex flex-row items-center mb-3 mx-4">
    //       <p className="text-grey33" style={textStyleSet.text_18_bold}>
    //         {translations.title}
    //       </p>
    //     </div>
    //     {displayedMockExams.length === 0 ? (
    //       <div
    //         style={styles.contentContainer}
    //         className="aspect-ratio-1-1:rounded-xl cursor-pointer" /* PHKL Custom */
    //         onClick={clickMockExam}
    //       >
    //         <div className="flex flex-row items-center">
    //           {/* PHKL Custom -s */}
    //           {/* <IconFontLayer
    //             size={36}
    //             backgroundSize={56}
    //             containerStyle={styles.iconContainer}
    //             name="a-mockexam"
    //             color={color.majorRed}
    //           /> */}
    //           <div
    //             className="flex justify-center items-center"
    //             style={{
    //               width: 56,
    //               height: 56,
    //               backgroundColor: "rgb(255, 228, 230)",
    //               borderWidth: 0,
    //               opacity: 1,
    //               borderRadius: 12,
    //             }}
    //           >
    //             <img src={mockExamIcon} alt="" />
    //           </div>
    //           {/* PHKL Custom -e */}
    //           <div className="flex flex-1 flex-col justify-center ml-3">
    //             <div className="flex flex-row items-center">
    //               <p className="text-grey33 flex-1" style={textStyleSet.text_16_med}>
    //                 {translations.enroll}
    //               </p>
    //               {/* PHKL Custom -s */}
    //               <div className="flex justify-end min-w-[80px]">
    //                 <div
    //                   className="self-center rounded-[4px] inline-block"
    //                   style={{ backgroundColor: color.greyBg }}
    //                 >
    //                   <p
    //                     className="px-2 py-1"
    //                     style={{ ...textStyleSet.text_12_med, color: color.grey33 }}
    //                   >
    //                     {translations.status_not_enrolled}
    //                   </p>
    //                 </div>
    //               </div>
    //               {/* PHKL Custom -e */}
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     ) : (
    //       <div>
    //         {displayedMockExams.map((mockExam: any) => (
    //           <div
    //             key={mockExam.courseId}
    //             style={styles.contentContainer}
    //             onClick={() => handlePress?.(mockExam)}
    //             className="aspect-ratio-1-1:rounded-xl mb-3"
    //           >
    //             <div className="flex flex-row items-center">
    //               {/* PHKL Custom -s */}
    //               {/* <IconFontLayer
    //                 size={36}
    //                 backgroundSize={56}
    //                 containerStyle={styles.iconContainer}
    //                 name="a-mockexam"
    //                 color={color.majorRed}
    //               /> */}
    //               <div
    //                 className="flex justify-center items-center"
    //                 style={{
    //                   width: 56,
    //                   height: 56,
    //                   backgroundColor: "rgb(255, 228, 230)",
    //                   borderWidth: 0,
    //                   opacity: 1,
    //                   borderRadius: 12,
    //                 }}
    //               >
    //                 <img src={mockExamIcon} alt="" />
    //               </div>
    //               {/* PHKL Custom -e */}
    //               <div className="flex flex-1 flex-col justify-center ml-3">
    //                 <div className="flex flex-row items-center">
    //                   <div className="flex-1">
    //                     <p className="text-grey99 flex-1" style={textStyleSet.text_14_med}>
    //                       {mockExam.course_name}
    //                     </p>
    //                     <p className="text-grey33 flex-1 mt-1" style={textStyleSet.text_14_med}>
    //                       {mappingStatusDesc(mockExam.enrollment_status)}
    //                     </p>
    //                   </div>
    //                   <div className="flex justify-end min-w-[80px]">
    //                     <div
    //                       className="self-center rounded-[4px] inline-block"
    //                       style={{
    //                         backgroundColor: mockExam.statusBackgroundColor,
    //                       }}
    //                     >
    //                       <p
    //                         className="px-2 py-1"
    //                         style={{
    //                           ...textStyleSet.text_12_med,
    //                           color: mockExam.statusTextColor,
    //                         }}
    //                       >
    //                         {mappingStatusText(mockExam.enrollment_status)}
    //                       </p>
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         ))}

    //         {/* View More/Less button */}
    //         {showViewMore && (
    //           <div className="flex justify-center">
    //             <button onClick={handleToggleExpand} className="flex items-center">
    //               <span style={textStyleSet.text_14_med} className="text-grey66 mr-1">
    //                 {isExpanded ? translations.viewLess : translations.viewMore}
    //               </span>
    //               <span className={`${isExpanded ? "inline-block rotate-180" : "inline-block"}`}>
    //                 <IconFont size={24} name={"arrow_down"} color={color.grey66} />
    //               </span>
    //             </button>
    //           </div>
    //         )}
    //       </div>
    //     )}
    //   </div>
    // );

    /* PHKL Layout */
    return (
      <div className="px-3 py-2 md:px-0">
        <div className="bg-white rounded-2xl">
          {/* Header */}
          <div className="flex items-center px-4 py-3 border-b border-gray-200">
            <p className="flex-1 text-[20px] font-semibold text-[#1A1A1A] leading-[28px]">
              {translations.title}
            </p>
          </div>

          {displayedMockExams.length === 0 ? (
            <div className="px-4 py-4">
              <div className="flex md:flex-row md:items-start md:gap-4">
                {/* Left info section */}
                <div className="flex flex-1">
                  {/* icon */}
                  <div className="w-[56px] mr-3 flex-shrink-0 flex items-start">
                    <div
                      className="flex justify-center items-center"
                      style={{
                        width: 56,
                        height: 56,
                        backgroundColor: "rgb(255, 228, 230)",
                        borderWidth: 0,
                        opacity: 1,
                        borderRadius: 12,
                      }}>
                      <img src={mockExamIcon} alt="" />
                    </div>
                  </div>

                  <div className="flex flex-col flex-1 min-w-0 justify-center">
                    {/*  content */}
                    <div
                      className="flex items-start gap-1 mt-1 text-grey33"
                      style={textStyleSet.text_16_med}>
                      <span className="break-words">{translations.enroll}</span>
                    </div>
                    <div className="flex items-center gap-2 pt-1">
                      <span
                        className="px-2 py-1"
                        style={{
                          backgroundColor: color.greyBg,
                          color: color.grey33,
                          ...textStyleSet.text_12_med,
                        }}>
                        {translations.status_not_enrolled}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Desktop buttons */}
                <div className="hidden md:flex flex-col gap-3 items-start">
                  <button
                    className="flex items-center justify-center w-[105px] h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
                    onClick={clickMockExam}>
                    {t("Common.enroll_now")}
                  </button>
                </div>
              </div>

              {/* Mobile buttons */}
              <div className="flex gap-2 mt-6 w-full justify-end md:hidden">
                <button
                  className="flex items-center justify-center w-full h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
                  onClick={clickMockExam}>
                  {t("Common.enroll_now")}
                </button>
              </div>
            </div>
          ) : (
            <div>
              {displayedMockExams.map((mockExam: any, index) => (
                <div key={index} className={`${index !== 0 ? "border-t border-gray-200" : ""}`}>
                  <div className="px-4 py-4">
                    <div className="flex md:flex-row md:items-start md:gap-4">
                      {/* Left info section */}
                      <div className="flex flex-1">
                        {/* icon */}
                        <div className="w-[56px] mr-3 flex-shrink-0 flex items-start">
                          <div
                            className="flex justify-center items-center"
                            style={{
                              width: 56,
                              height: 56,
                              backgroundColor: "rgb(255, 228, 230)",
                              borderWidth: 0,
                              opacity: 1,
                              borderRadius: 12,
                            }}>
                            <img src={mockExamIcon} alt="" />
                          </div>
                        </div>

                        <div className="flex flex-col flex-1 min-w-0">
                          <span className="text-[17px] font-semibold leading-[24px]">
                            {mockExam.course_name}
                          </span>
                          <div className="flex items-center gap-2 pt-1">
                            <span
                              className="px-2 py-1"
                              style={{
                                backgroundColor: mockExam.statusBackgroundColor,
                                color: mockExam.statusTextColor,
                                ...textStyleSet.text_12_med,
                              }}>
                              {mappingStatusText(mockExam.enrollment_status)}
                            </span>
                          </div>

                          <p className="text-grey33 flex-1 mt-1" style={textStyleSet.text_14_med}>
                            {mappingStatusDesc(mockExam.enrollment_status)}
                          </p>
                        </div>
                      </div>

                      {/* Desktop buttons */}
                      <div className="hidden md:flex flex-col gap-3 items-start">
                        <button
                          className="flex items-center justify-center w-[105px] h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
                          onClick={() => handlePress?.(mockExam)}>
                          {t("Common.view_detail")}
                        </button>
                      </div>
                    </div>

                    {/* Mobile buttons */}
                    <div className="flex gap-2 mt-6 w-full justify-end md:hidden">
                      <button
                        className="flex items-center justify-center w-full h-9 rounded text-sm font-semibold text-white bg-[#E8192C] hover:bg-[#d32f2f]"
                        onClick={() => handlePress?.(mockExam)}>
                        {t("Common.view_detail")}
                      </button>
                    </div>
                  </div>
                </div>
              ))}

              {/* View More/Less button */}
              {showViewMore && (
                <div className="flex justify-center border-t border-gray-200">
                  <button onClick={handleToggleExpand} className="flex items-center">
                    <span style={textStyleSet.text_14_med} className="text-grey66 mr-1">
                      {isExpanded ? translations.viewLess : translations.viewMore}
                    </span>
                    <span className={`${isExpanded ? "inline-block rotate-180" : "inline-block"}`}>
                      <IconFont size={24} name={"arrow_down"} color={color.grey66} />
                    </span>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
    // PHKL Custom -e
  },
);
